module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-deal-bea2b385ea858b27b73f79dd452ee084.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-deal.jpg
// module id = 354
// module chunks = 2